import { render, staticRenderFns } from "./InterfaceDocuments.vue?vue&type=template&id=2817bc04"
import script from "./InterfaceDocuments.vue?vue&type=script&lang=js"
export * from "./InterfaceDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports